import type {Snapshot} from '@platform/contracts/x';
import {useCountdown} from '@platform/client';
import {useCopy} from '@platform/ui/config';
import {canBuy} from './roomFlow';
import {CountdownClock} from './CountdownClock';
import './PurchaseDeadline.css';

// Main catalogue, popup and basket share the same authoritative sale deadline.
// A future offer without a published deadline must never show an invented timer.
export function PurchaseDeadline({state,compact=false,hideTimerLabel=false}:{state:Snapshot;compact?:boolean;hideTimerLabel?:boolean}){
 const t=useCopy(),seconds=useCountdown(state),timed=!!state.salesCloseAtUtc&&Number.isFinite(Date.parse(state.salesCloseAtUtc));
 const countdown=canBuy(state)&&timed,label=t(canBuy(state)?timed?'flow.salesRemaining':'flow.salesOpen':'room.closed');
 return <div className="purchase-deadline" data-compact={compact} data-ui="purchase-deadline">
  {(!hideTimerLabel||!countdown)&&<span>{label}</span>}
  {countdown&&(compact?<CountdownClock seconds={seconds} label={label} hideLabel/>:<b role="timer" aria-label={hideTimerLabel?label:undefined} aria-live="off">{String(Math.floor(seconds/60)).padStart(2,'0')}:{String(seconds%60).padStart(2,'0')}</b>)}
 </div>;
}
